import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import patientimg from "../../patient.jpg";
import doctor from "../../doctor.jpg";
import nurse from "../../nurse.jpg";
import Register from "./Register";

function Login({ isOpen, onClose, loginFor }) {
  // ✅ Default value
  const Navigate = useNavigate();
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  if (!isOpen) return null;

  // Helper function to get header text based on loginFor prop
  const getHeaderText = () => {
    switch (loginFor) {
      case "patient":
        return {
          title: "Patient Login / Register",
          subtitle: "Access your health dashboard",
          img: patientimg,
        };
      case "doctor":
        return {
          title: "Doctor Login",
          subtitle: "Access your medical practice dashboard",
          img: doctor,
        };
      case "nurse":
        return {
          title: "Nurse Login",
          subtitle: "Access your nursing dashboard",
          img: nurse,
        };
      default:
        return {
          title: "Patient Login / Register",
          subtitle: "Access your health dashboard",
          img: patientimg,
        };
    }
  };

  // Helper function to get navigation route based on loginFor
  const getNavigationRoute = () => {
    switch (loginFor) {
      case "patient":
        return "/dashboardwhite";
      case "doctor":
        return "/doctordashboard";
      case "nurse":
        return "/nursedashboard";
      default:
        return "/dashboardwhite";
    }
  };

  const headerInfo = getHeaderText();

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl relative flex gap-6 h-[500px]">
          {/* Left Side - Form */}
          <div className="w-1/2 relative p-10">
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl"
            >
              &times;
            </button>

            {/* Header */}
            <div className="mb-6 text-center">
              <h2 className="text-2xl font-bold">{headerInfo.title}</h2>
              <p className="text-gray-500">{headerInfo.subtitle}</p>
            </div>

            {/* Form */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                console.log("Login submitted");
              }}
              className="space-y-4"
            >
              {/* Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="your@email.com"
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>

              {/* Password */}
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  placeholder="Enter your password"
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>

              {/* Login Button */}
              <button
                type="submit"
                className="w-full bg-blue-600 text-white rounded-md py-2 font-medium hover:bg-blue-700 transition"
                onClick={() => {
                  Navigate(getNavigationRoute());
                }}
              >
                Login
              </button>

              {/* Register Button - Only show for patients */}
              {loginFor === "patient" && (
                <button
                  type="button"
                  onClick={() => setIsRegisterOpen(true)}
                  className="w-full border border-gray-300 rounded-md py-2 font-medium text-gray-700 hover:bg-gray-100 transition"
                >
                  Create New Account
                </button>
              )}
            </form>
          </div>

          {/* Right Side - Image */}
          <div className="w-1/2 h-full flex items-center justify-center">
            <img
              src={headerInfo.img}
              alt="Descriptive alt text"
              className="object-cover h-full w-full"
            />
          </div>
        </div>
      </div>

      {/* Register Modal - Only render for patients */}
      {loginFor === "patient" && (
        <Register
          isOpen={isRegisterOpen}
          onClose={() => setIsRegisterOpen(false)}
          onBackToLogin={() => {
            setIsRegisterOpen(false);
          }}
        />
      )}
    </>
  );
}

export default Login;
